import { isDhMarketEstado } from './fastchipClusterRules';

/**
 * TEMPORÁRIO (pedido Eder — bater meta): contratos por entrega com token
 * DH (`DH` / `DH - RJ/MG/ES`) podem marcar suspensão sem Fastchip.
 * Remover quando a meta não precisar mais desta exceção.
 *
 * ER2 operacional (`ER2 - RJ/EP/MG`) NÃO mantém esta excepção.
 * Espelha `ContractSuspensionEligibility` na GettelApi.
 */
export const TEMPORARY_DH_DELIVERY_SUSPENSION_TOKEN = 'DH - RJ/MG/ES';
export const TEMPORARY_DH_DELIVERY_SUSPENSION_CANONICAL = 'DH';

function normalizeClusterToken(clusterToken: string): string {
  return clusterToken.trim().toUpperCase();
}

/** Indica se o token de cluster permite suspensão em contrato sem Fastchip. */
export function allowsSuspensionWithoutFastchip(clusterToken: string | null | undefined): boolean {
  if (!clusterToken || !clusterToken.trim()) return false;
  const t = normalizeClusterToken(clusterToken);
  return t === 'DH' || t === 'DH - RJ/MG/ES';
}

/**
 * Política unificada do modal: DH por entrega sem Fastchip.
 * - Token DH / DH - RJ/MG/ES → libera
 * - Token vazio + UF RJ/MG/ES → libera (race do autofill no modal)
 * - Token preenchido não-DH (incl. ER2 operacional) → NÃO libera
 */
export function allowsDhDeliverySuspensionWithoutFastchip(options: {
  clusterToken?: string | null;
  clientEstado?: string | null;
}): boolean {
  const token = options.clusterToken?.trim() ?? '';
  if (token) {
    return allowsSuspensionWithoutFastchip(token);
  }
  return isDhMarketEstado(options.clientEstado);
}

/** Suspensão permitida se Fastchip ou exceção temporária DH por entrega. */
export function allowsSuspension(
  fastchip: boolean,
  clusterToken: string | null | undefined,
  clientEstado?: string | null
): boolean {
  return (
    fastchip ||
    allowsDhDeliverySuspensionWithoutFastchip({ clusterToken, clientEstado })
  );
}
